import { createSlice} from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface ParkingState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
  parkingData: any | null;
}

const initialState: ParkingState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
  parkingData: null
};

export const parkingSlice = createSlice({
  name: "parkings",
  initialState,
  reducers: {
    setParkings: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    setSelectedParking: (state, action) => {
      state.parkingData = action.payload;
    },
    resetParkings: (state) => {
      state = initialState;
    },
  },
});

export const { setParkings, setSelectedParking, resetParkings } = parkingSlice.actions;

export const getParkingSpaces = (state: RootState) => state.parkings.data;
export const getParkingTotalRecord = (state: RootState) =>
  state.parkings.totalRecords;
export const getActiveParkingSpaces = (state: RootState) =>
  state.parkings.data &&
  state.parkings.data.filter(
    (parking: any) =>
      parking.currentStatus === "active" || parking.currentStatus === "accepted"
  );
export const getInActiveParkingSpaces = (state: RootState) =>
  state.parkings.data &&
  state.parkings.data.filter(
    (parking: any) => parking.currentStatus === "pending"
  );

export const getSelectedParkingSpace = (state: RootState) => state.parkings.parkingData;

export const getSelectedParkingBlackout = (state: RootState) => {
  let data : any = []
  state.parkings.parkingData &&
  state.parkings.parkingData.blackoutDates.forEach((element: any) => {
    if (element.status === true) {
      data.push(new Date(element.date))
    }
  });
  return data;
}

export const getVehicleCategory = (state: RootState) => {
  var category = state.parkings.parkingData;
  let categoryData: any = [];
  category?.parkingCategoryResDTOS && category?.parkingCategoryResDTOS.map((obj: any) => {
    categoryData.push({
      value: obj.categoryName + " - " + obj.subCategoryName + " - " + obj.bookingType,
      key: obj.id,
      minimumBookingHours: obj.minimumBookingHours,
      dailyRate: obj.dailyRate,
      bookingUnits: obj.bookingUnits,
      type: obj.type,
      categoryType: obj.categoryType,
      subCategoryName:obj.subCategoryName
    }
    )
  });
  return categoryData
};

export default parkingSlice.reducer;
